import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getUserSelfThunk } from './UserThunk';
import { UserRole } from '../../types/userRole.types';
import { RootState } from '../store';
import { EmailTemplate } from '../../types/emailTemplate.types';

const SLICE_NAME = 'user';

interface UserState {
  roles: UserRole[];
  emailTemplates: EmailTemplate[];
  configuration?: {
    fcm_token?: unknown;
  };
  id?: number;
  email?: string;
  avatar?: string;
  fullName?: string;
}

const initialState: UserState = {
  roles: [],
  emailTemplates: [],
};

export const userSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    updateEmailTemplate: (state, action) => ({
      ...state,
      emailTemplates: state.emailTemplates.map((item: EmailTemplate) => {
        if (item.code === action.payload.code) return action.payload;

        return item;
      }),
    }),
  },
  extraReducers: builder => {
    // @ts-ignore
    builder.addCase(getUserSelfThunk.pending, (state, action) => ({
      ...userSlice.getInitialState,
    }));
    builder.addCase(
      getUserSelfThunk.fulfilled,
      (state, action: PayloadAction<Partial<UserState>>) => {
        return {
          ...state,
          ...action.payload,
        }
      },
    );
  },
});

export const getUserEmailTemplates = (state: RootState): EmailTemplate[]  => state.user.emailTemplates;
export const getUserRoles = (state: RootState) => state.user.roles;
export const getUserId = (state: RootState) => state.user.id;

export const { updateEmailTemplate } = userSlice.actions;

export default userSlice.reducer;
